import {endpoints} from './endpoints'
import request from '../request'

export function createProspectChatRoom (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createProspectChatRoom,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function createUserChatRoom (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createUserChatRoom,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function createProjectLineChatRoom (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createProjectLineChatRoom,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function addUserToChatRoom (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.addUserToChatRoom,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function removeUserFromChatRoom (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.removeUserFromChatRoom,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function addMessageToChatRoom (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.addMessageToChatRoom,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getUserChatRooms (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getUserChatRooms,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getChatRoomMessages (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getChatRoomMessages,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getCompanyUserListToChat (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getCompanyUserListToChat,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getCompanyProjectLinesToChat (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getCompanyProjectLinesToChat,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function chatFileToItem (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.chatFileToItem,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function deleteMessageFromChatRoom (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.deleteMessageFromChatRoom,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getProjectLineMessageCounts (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getProjectLineMessageCounts,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function markMessagesAsSeen (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.markMessagesAsSeen,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getProjectLineFiles (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getProjectLineFiles,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}